import { Check } from '@phosphor-icons/react';

export default function OrderConfirmedScreen({ message, onBack }) {
  return (
    <div className="flex flex-col items-center justify-center py-16" data-testid="order-confirmed">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
        <Check size={32} className="text-green-600" />
      </div>
      <h2 className="text-xl font-bold text-[#111827] mb-2">Encomenda Criada!</h2>
      <p className="text-sm text-[#6B7280] mb-6">{message}</p>
      <button onClick={onBack} data-testid="back-to-orders-btn"
        className="px-6 py-2.5 bg-[#0F1829] text-white text-sm font-medium rounded-lg hover:bg-[#001f6e] transition-colors">
        Ver Encomendas
      </button>
    </div>
  );
}
